<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 xl:w-1/5 sm:m-0 m-4 m">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">

            <vx-card no-radius no-shadow>
              <div class="vx-card__title mb-4">
                <h4 class="mb-4">{{ $t('auth.change_password.title') }}</h4>
                <p>{{ $t('auth.change_password.instructions') }}</p>
              </div>

              <vs-input
                data-vv-validate-on="blur"
                v-validate="'required|min:8'"
                type="password"
                name="password"
                icon-no-border
                icon="icon icon-lock"
                icon-pack="feather"
                :label-placeholder="$t('auth.change_password.input.password')"
                v-model="password"
                class="w-full mt-10" 
              />
              <span class="text-sm text-danger">{{ errors.first('password') }}</span>

              <vs-input
                data-vv-validate-on="blur"
                v-validate="'required|min:8'"
                type="password"
                name="passwordConfirmation"
                icon-no-border
                icon="icon icon-lock"
                icon-pack="feather"
                :label-placeholder="$t('auth.change_password.input.password_confirmation')"
                v-model="passwordConfirmation"
                class="w-full mt-10" 
              />
              <span class="text-sm text-danger">{{ errors.first('passwordConfirmation') }}</span>

              <div class="mt-10">
                <vs-button :disabled="!validateForm" @click="changePassword">{{ $t('auth.change_password.title') }}</vs-button>
              </div>
              
            </vx-card>

          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>

import loader from "@/modules/Shared/Mixins/loader";
import AuthServices from '@/modules/Auth/Services/AuthServices.js'

export default {
  mixins: [loader],
  data () {
    return {
      password: '',
      passwordConfirmation: '',
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
        && this.password.length >=8
        && this.passwordConfirmation.length >=8
        && this.password === this.passwordConfirmation
    }
  },
  methods: {
    async changePassword() {
      await this.loadAndNotify(async () => {
        const payload = {
          hash: this.$route.query.hash,
          password: this.password,
          password_confirmation: this.passwordConfirmation
        }

        const response = await AuthServices.passwordReset(payload)

        if (response.status !== 200) {
          return
        }

        await this.$router.push(`/${this.$route.params.language}/login`)
      }, false)
    },
  }
}
</script>
